module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av559-c44c2ed2aab70ce7009078946011ad35.jpg";